import { NskResponse } from '~/models/Api';
import { postRequest } from '~/utils/api/api_handler';
import { DealConstruction } from '~/models/DealConstruction';

// https://itandi-dev.atlassian.net/browse/NSKDEV-1608
// updateSeqV2以外削除する

const paths = {
  updateSeq: '/vendors/deals/:deal_id/deal_estimations/update_seq',
  updateSeqV2: '/vendors/deals/:deal_id/deal_estimations/update_seq_v2'
};

export const updateSeq = async (
  dealEstimations: DealConstruction[],
  dealId: number
): Promise<NskResponse<void>> =>
  postRequest(paths.updateSeq.replace(':deal_id', String(dealId)), {
    dealEstimations
  });

export const updateSeqV2 = async (
  dealEstimations: DealConstruction[],
  dealId: number
): Promise<NskResponse<void>> =>
  postRequest(paths.updateSeqV2.replace(':deal_id', String(dealId)), {
    dealEstimations
  });
